import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { db } from './firebase';
import { Cart, CartItem } from '../types';

export const getCart = async (userId: string): Promise<Cart | null> => {
  const cartDoc = await getDoc(doc(db, 'carts', userId));
  
  if (cartDoc.exists()) {
    return cartDoc.data() as Cart;
  }
  
  return null;
};

export const addToCart = async (userId: string, item: CartItem) => {
  const cartRef = doc(db, 'carts', userId);
  const cartDoc = await getDoc(cartRef);
  
  if (cartDoc.exists()) {
    const cart = cartDoc.data() as Cart;
    const existingItemIndex = cart.items.findIndex(i => i.artworkId === item.artworkId);
    
    if (existingItemIndex > -1) {
      cart.items[existingItemIndex].quantity += item.quantity;
    } else {
      cart.items.push(item);
    }
    
    await updateDoc(cartRef, {
      items: cart.items,
      updatedAt: new Date(),
    });
  } else {
    await setDoc(cartRef, {
      userId,
      items: [item],
      updatedAt: new Date(),
    });
  }
};

export const removeFromCart = async (userId: string, artworkId: string) => {
  const cartRef = doc(db, 'carts', userId);
  const cartDoc = await getDoc(cartRef);
  
  if (cartDoc.exists()) {
    const cart = cartDoc.data() as Cart;
    cart.items = cart.items.filter(item => item.artworkId !== artworkId);
    
    await updateDoc(cartRef, {
      items: cart.items,
      updatedAt: new Date(),
    });
  }
};

export const updateCartItemQuantity = async (userId: string, artworkId: string, quantity: number) => {
  const cartRef = doc(db, 'carts', userId);
  const cartDoc = await getDoc(cartRef);
  
  if (cartDoc.exists()) {
    const cart = cartDoc.data() as Cart;
    const itemIndex = cart.items.findIndex(i => i.artworkId === artworkId);
    
    if (itemIndex > -1) {
      cart.items[itemIndex].quantity = quantity;
      
      await updateDoc(cartRef, {
        items: cart.items,
        updatedAt: new Date(),
      });
    }
  }
};